import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MinuteApprovalParameterConstraintDTO, MinuteApprovalParameterConstraintViewModel, MinuteApprovalParameterDTO } from '../../interfaces/minue-request-approval-paramters.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MinuteRequestApprovalRuleService } from '../../services/minute-request-approval-rule.service';
import { MinuteApprovalConditionComparator } from '../../interfaces/minute-request-approval-rule.interface';
import { AddUpdateApprovalMinuteConditionDTO, NewMinuteRequestConditionsViewModel } from '../../interfaces/minute-request-approval-rule-manage.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-minute-reques-approval-conditions',
  templateUrl: './register-minute-reques-approval-conditions.component.html',
  styleUrl: './register-minute-reques-approval-conditions.component.scss'
})
export class RegisterMinuteRequesApprovalConditionsComponent implements OnInit{

  public newConditionsForm: FormGroup;
  public parameters: MinuteApprovalParameterDTO[];


  constructor(private dialogRef: MatDialogRef<RegisterMinuteRequesApprovalConditionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewMinuteRequestConditionsViewModel,
    private minuteRequestApprovalRuleService: MinuteRequestApprovalRuleService,
    private fb: FormBuilder
  ){
    this.newConditionsForm = this.fb.group({
      minuteRequestApprovalRuleId: [this.data.minuteRequestApprovalRuleId],
      conditions: this.fb.array([])
    });
  }

  get conditions() {
    return this.newConditionsForm.get('conditions') as FormArray;
  }

  getConditionGroup(index: number): FormGroup{ 
    return this.conditions.at(index) as FormGroup;
  }

  ngOnInit(): void {
    this.getParameters();
    this.addConditions();
  }

  public getParameters() {
    this.minuteRequestApprovalRuleService.getAllMinuteApprovalParameters()
    .subscribe(res => this.parameters = res);
  }

  public clickCloseDialog(){
    this.dialogRef.close(false);
  }

  public addConditions() {
    const conditionGroup = this.fb.group({
      parameterId: [null, Validators.required],
      comparator: [null, Validators.required],
      value: [null, Validators.required]
    });

    this.conditions.push(conditionGroup);
  }


  public removeCondition(idx: number) {
    this.conditions.removeAt(idx);
  }

  public submit() {
    const {minuteRequestApprovalRuleId, conditions} = this.newConditionsForm.value;
  
    const addConditions: AddUpdateApprovalMinuteConditionDTO[] = conditions.map((c: { parameterId: any; comparator: any; value: any; }) => <AddUpdateApprovalMinuteConditionDTO>{
      minuteRequestApprovalParameterId: c.parameterId,
      comparator: c.comparator,
      value: c.value
    });
    const request$ = this.minuteRequestApprovalRuleService.addMinuteRequestApprovalConditions(minuteRequestApprovalRuleId, addConditions);
    Swal.fire({
      title: 'Registrando nuevas condiciones',
      didOpen: () => {
        Swal.showLoading();
        request$.subscribe({
          next:(res) => {
            Swal.fire({
              icon: 'success',
              title: res.resultMessage,
              didClose: () => this.dialogRef.close(true)
            })
          },
          error: (err) => {
            Swal.fire({
              icon: 'error',
              title: err.error.resultMessage || 'Ha ocurrido un error'
            })
          }
        });
      }
    })

  }

}
